export class Validators {
  static required = (val: any) => {
    if (val === null || val === undefined || val.length < 1) return { value: false, name: 'required' };
    return { result: true, name: 'required' };
  }

  static email = (val: any) => {
    // var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return { result: re.test(String(val).toLowerCase()), name: 'email' };
  }

  static number = (val: any) => {
    return { result: !isNaN(val), name: 'number' };
  }

  static rfc_fisica = (val: any) => {
    const rfc = /^[A-Za-z]{4}[-]{1}[0-9]{6}[-]{1}[0-9A-Za-z]{3}$/
    return { result: rfc.test(String(val)), name: 'rfc_fisica' };
  }

  static rfc_moral = (val: any) => {
    const rfc = /^[A-Za-z]{3}[-]{1}[0-9]{6}[-]{1}[0-9A-Za-z]{3}$/
    return { result: rfc.test(String(val)), name: 'rfc_moral' };
  }

  static maxLength = (maxLength: any) => {
    return (val: string) => ({ result: val.length <= maxLength, name: 'maxLength' })
  }

  static minLength = (minLength: any) => {
    return (val: string) => ({ result: val.length >= minLength, name: 'minLength' })
  }

  static max = (max: number) => {
    return (val: number) => ({ result: val < max, name: 'max' })
  }
}
export interface FormOption {
  Value: any,
  Label: string
}
export interface FormField {
  Type: string,
  Name: string,
  Label: string,
  Value: any,
  ValueAt: any,
  Validators: ((...args: any) => any)[],
  Col: number,
  Options: FormOption[],
  Invalid: boolean,
  ErrorMessages: string[],
  WarningMessages: string[],
  Blur: boolean,
  Changed: boolean,
  Disabled: boolean,
  [key: string]: string | Validators[] | number | FormOption[] | boolean | any;
}
export interface FormGroup {
  Fields: FormField[],
  Options: string[],
  Title: string,
  Invalid: boolean,
  Change?: any,
}

export class FormOpV2 {
  // static Field(Type: string, Name: string, Label: string, Value: string, Validators: Validators[], Col: number, Options: FormOption[] = []): FormField {
  //   return {
  //     Type, Name, Label, Value, Validators, Col, Options, Invalid: true, Blur: false
  //   }
  // }

  // static Form(Fields: FormField[] = [], Options: string[] = [], Title: string = ''): FormGroup {
  //   // fields.push({type: 'id', name: 'id', label: ''})
  //   return {
  //     Fields, Options, Title, Invalid: true
  //   }
  // }
  static Form(Fields: FormField[] = [], Actions: string[] = [], Title: string = '') {
    let Change = (form: FormGroup) => {

    }
    return { Fields, Actions, Title, Change };
  }
}

export class Form {
  Fields: FormField[];
  Actions: string[];
  Title: string;
  Subs: any = {};
  Invalid: boolean = true;
  // Change: any;
  // Component: any;

  constructor(Fields: FormField[] = [], Actions: string[] = [], Title: string = '') {
    this.Fields = Fields;
    this.Actions = Actions;
    this.Title = Title;
    // this.Subs = Changes;
    // this.Change = (form: Form) => {
    //   this.Fields = form.Fields;
    //   this.Actions = form.Actions;
    //   this.Title = form.Title;
    //   // console.log(this);

    // }
  }

  FormChange(form: Form) {
    // console.log(this);
    let Forfm = new Form(form.Fields, form.Actions, form.Title)
    console.log(Forfm);

    // this.Fields = form.Fields;
    // this.Actions = form.Actions;
    // this.Title = form.Title;
    // this.Component.setState({Form: this})
  }

  Sub(fieldName: string) {
    this.Subs.push({})
  }

  Prueba() {
    // this.
    // this.Component.setState({Form: new Form([], [], '', null)})
  }

  static Field(Type: string, Name: string, Label: string, Value: any, Validators: any[], Col: number, Options: FormOption[] = [], ErrorMessages: string[] = [], WarningMessages: string[] = [], Changed: boolean = false, Disabled: boolean = false, Accept: string = '', ApiUrl: string = ''): FormField {
    if ((Type === 'date' || Type === 'date-hour') && !Value) Value = null;
    return {
      Type, Name, Label, Value, Validators, Col, Options, Invalid: true, Blur: false, ValueAt: null, ErrorMessages, WarningMessages, Changed, Disabled, Accept, ApiUrl
    }
  }

  static FieldL(Type: string, Name: string, Label: string, Value: any, Validators: any[], Col: number, Options: FormOption[] = [], Disabled: boolean = false): FormField {
    if (Type === 'date' || Type === 'date-hour') Value = null;
    return {
      Type, Name, Label, Value, Validators, Col, Options, Invalid: true, Blur: false, ValueAt: null, ErrorMessages: [], WarningMessages: [], Changed: false, Disabled
    }
  }

  static Section(Label: string, Value: any = 1, Col = 12): FormField {
    return {
      Type: 'section', Name: '', Label, Value, Validators: [], Col, Options: [], Invalid: false, Blur: true, ValueAt: null, ErrorMessages: [], WarningMessages: [], Changed: true, Disabled: true,
    }
  }

  static Space(Col: number): FormField {
    return {
      Type: 'space', Name: '', Label: '', Value: '', Validators: [], Col, Options: [], Invalid: false, Blur: true, ValueAt: null, ErrorMessages: [], WarningMessages: [], Changed: true, Disabled: true,
    }
  }

  static Button(Value: any, Label: string, Col: number, Hidden: boolean, Disabled: boolean = false): FormField {
    return {
      Type: Hidden ? 'hidden' : 'button', Name: Value, Label, Value, Validators: [], Col, Options: [], Invalid: false, Blur: true, ValueAt: null, ErrorMessages: [], WarningMessages: [], Changed: true, Disabled,
    }
  }

  static SetInvalidField(formGroup: FormGroup | Form, fieldName: string, errorMessages: string[]) {
    let newForm = formGroup;
    newForm = this.FieldMod(newForm, fieldName, 'Invalid', errorMessages.length > 0);
    newForm = this.FieldMod(newForm, fieldName, 'ErrorMessages', errorMessages);
    newForm.Invalid = formGroup.Fields.some(field => field.Invalid)
    return newForm
  }

  static SetWarningField(formGroup: FormGroup | Form, fieldName: string, warningMessages: string[]) {
    return this.FieldMod(formGroup, fieldName, 'WarningMessages', warningMessages);
  }

  static FieldMod(formGroup: FormGroup | Form, fieldName: string, fieldProp: any, newVal: any) {
    var fieldIndex = formGroup.Fields.findIndex((field) => field.Name === fieldName);
    if (fieldIndex < 0) {
      console.error(`[FieldMod] Campo '${fieldName}' en formulario '${formGroup.Title}' no existe`)
      return formGroup
    }
    formGroup.Fields[fieldIndex][fieldProp] = newVal;
    // console.log(formGroup)
    return formGroup;
  }

  static GetFieldProp(formGroup: FormGroup, fieldName: string, fieldProp: any) {
    var fieldIndex = formGroup.Fields.findIndex((field) => field.Name === fieldName);
    if (fieldIndex < 0) {
      console.error(`[GetFieldProp] Campo '${fieldName}' en formulario '${formGroup.Title}' no existe`)
      return null;
    }
    return formGroup.Fields[fieldIndex][fieldProp];
  }

  static FieldOptions(formGroup: FormGroup, fieldName: string, newOptions: any[], opVal: string, opLabel: string) {
    var format: FormOption[] = newOptions.map((option) => ({ Value: option[opVal] + '', Label: option[opLabel] + '', ...option }))
    return Form.FieldMod(formGroup, fieldName, 'Options', format);
  }

  static Change(form: Form, dfield: FormField) {
    for (let name in form.Subs) {
      if (name !== dfield.Name) continue;
      let field = form.Fields.find((findField) => findField.Name === name)
      form.Subs[name](field)
    }
    return form;
  }

  static ValueChange(form: Form, data: {}) {
    // console.log('value change', form);
    form.Subs = data;
    return form;
  }

  static Patch(form: Form, defs: { [key: string]: string }, callChange: boolean = false) {
    // console.log(defs)
    let stateFields = form.Fields, newForm = form;
    for (let id in defs) {
      stateFields.forEach((field, i) => {
        if (field.Name === id) {
          stateFields[i].Value = defs[id];
          if (field.Type === 'autocomplete') {
            // stateFields[i].Value = null;
            // stateFields[i].ValueAt = defs[id];
            stateFields[i].Value = defs[id] || '';
            stateFields[i].ValueAt = null;
          }
          stateFields[i].Invalid = !Form.ValidateField(form, field);

          if (callChange)
            return Form.Change(form, stateFields[i]);
        }
      })
    }
    newForm.Fields = stateFields;
    const valid = Form.ValidateForm(form);
    newForm.Invalid = valid !== true;
    // console.log('patch', newForm);
    return newForm;
  }

  static Reset(form: Form) {
    var newFields: FormField[] = form.Fields.map((field) => {
      let Value;
      if (field.Type === 'date' || field.Type === 'date-hour') Value = new Date();
      else if (field.Type === 'select_multiple') Value = [];
      else Value = ''
      return ({ ...field, Value });
    })
    form.Fields = newFields;
    return form;
  }

  static ValidateField(form: Form, field: FormField) {
    let isInvalid = field.Validators.some((validator) => !validator(field.Value).result);
    if (isInvalid && field.Changed) {
      Form.SetInvalidField(form, field.Name, ['Campo Invalido']);
    } else {
      Form.SetInvalidField(form, field.Name, []);
    }

    return !isInvalid
  }

  static ValidateForm(form: Form) {
    const indx = form.Fields.findIndex((field, fi) => !Form.ValidateField(form, field));
    if (indx !== -1) {
      return { name: form.Fields[indx].Label };
    }
    return true;
  }

  static FieldsValues(form: FormGroup) {
    let Vals: any = {}
    form.Fields.forEach((Field) => {
      if (!['section', 'button', 'space'].includes(Field.Type)) {
        Vals[Field.Name] = Field.Value;
      }
    })
    return Vals;
  }

  static ToDatetime(val: string | Date) {
    let valPar = new Date(val);
    return `${valPar.getFullYear()}-${valPar.getUTCMonth() + 1}-${valPar.getUTCDate()} ${valPar.getUTCHours()}:${valPar.getUTCMinutes()}:${valPar.getUTCSeconds()}`
  }

  static GetValues(form: FormGroup, values: string[]): object {
    let foundValues: any = {};
    form.Fields.forEach(field => {
      if(values.includes(field.Name))
        foundValues[field.Name]  = field.Value;
    })
    return foundValues;
  }
}